import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const baseUrl = API_BASE_URL_ENV() + "/users";

export async function getProfile() {
	return http.get(`${baseUrl}/profile`);
}

export async function updateProfile(data) {
	return http.put(baseUrl, data);
}

export async function updateAvatar(file) {
	let data = {
		avatar: file,
	};
	return http.put(`${baseUrl}/imageProfile`, data);
	// return http.put(`${baseUrl}/imageProfile`, formData, {
	// 	headers: { "Content-Type": "multipart/form-data" },
	// });
}
